"use client";

import Link from "next/link";
import { useAuthLeftContent } from "~/app/auth/_context/AuthLeftContentContext";
import { Logo } from "~/components/ui/Logo";

export function AuthNav() {
  const { leftContent } = useAuthLeftContent();

  return (
    <nav className="fixed inset-x-0 top-0 z-50 flex items-center justify-between bg-surface/90 px-4 py-3 backdrop-blur-sm sm:px-6 sm:py-4 md:absolute md:bg-transparent md:py-5 md:backdrop-blur-none md:px-10">
      <Logo className="shrink-0 md:hidden" variant="default" />
      <Logo className="hidden shrink-0 md:block" variant="light" />
      {leftContent.hideHomeLink ? null : (
        <Link
          className="rounded-full px-3 py-1.5 text-xs font-medium text-navy transition hover:bg-[rgba(13,35,64,0.06)] hover:text-accent-dark sm:px-4 sm:text-sm"
          href={leftContent.homeHref ?? "/"}
        >
          {leftContent.homeLabel ?? "← Home"}
        </Link>
      )}
    </nav>
  );
}
